import { any, pipe, curry } from 'lodash/fp';

const matchesRoute = (pathname, route) =>
  new RegExp(`^${route}/?$`, 'i').test(pathname);

/* (pathname: string) => (routes: string[]) => boolean */
const createRoutesMatcher = pipe(curry(matchesRoute), any);

export default createRoutesMatcher;
